export const PLACEMENT_CRM_TOKEN_NAME = 'placement-crm-token'
